import React from "react";
import dynamic from "next/dynamic";
import styled from "styled-components";
import sanitize from "sanitize-html";
import BusinessTaxAdvisoryHeroStyles from "./BusinessTaxAdvisoryHeroStyles";
import PropTypes from "prop-types";

const TrustPilotComponent = dynamic(
  () => import("../TrustPilot/TrustPilotComponent"),
  { ssr: false }
);

const sanitizeSettings = {
  allowedTags: ["p", "ol", "ul", "li", "h2", "img", "strong", "br"],
  allowedAttributes: {
    img: ["src", "alt", "style", "height", "width"],
  },
};

const TPStyles = styled.div`
  position: relative;

  .tp-container {
    max-width: 100%;

    &.mobile {
      display: block;
      margin-bottom: 40px;
      ${(props) => props.theme.media.md} {
        display: none;
      }
    }

    &.desktop {
      display: none;
      ${(props) => props.theme.media.md} {
        display: block;
      }
    }
  }
`;

const SmallBusinessTaxesHero = ({ data, onCtaClicked }) => {
  const { title, subtitle, ctaText, image } = data;

  console.log(data);

  return (
    <BusinessTaxAdvisoryHeroStyles image={image.url}>
      <div className="container-fluid hero">
        <div className="row">
          <div className="left-half-container col-md-12">
            <h1 className="desktop hero-title text-left">{title}</h1>
            <div
              className="hero-subtitle"
              dangerouslySetInnerHTML={{
                __html: sanitize(subtitle, sanitizeSettings),
              }}
            ></div>
            <div className="name-your-business-container">
              <button onClick={onCtaClicked} className="btn btn-secondary cta">
                {ctaText}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="tp">
        <TPStyles>
          <div className="tp-container">
            <TrustPilotComponent
              height="75px"
              templateID="5406e65db0d04a09e042d5fc"
            />
          </div>
        </TPStyles>
      </div>
    </BusinessTaxAdvisoryHeroStyles>
  );
};

SmallBusinessTaxesHero.propTypes = {
  data: PropTypes.object.isRequired,
  onCtaClicked: PropTypes.func.isRequired,
};

export default SmallBusinessTaxesHero;
